import { createAction, handleActions } from 'redux-actions'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'project'

export const FETCH_PROJECT = createAction(`${BASE_ACTION_NAME}/fetch_participant`)
export const FETCH_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/fetch_participant/success`)
export const FETCH_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/fetch_participant/failure`)

/////////////////
//// Reducer ////
/////////////////

const initialState = {}

export default handleActions(
  {
    [FETCH_PROJECT_SUCCESS]: (state, action) => {
      const project = action.payload.data
      return {
        ...state,
        title: project.title,
        isStarted: project.is_started,
        imageUrl: project.image
      }
    }
  },
  initialState
)
